import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { InlineMessage, INLINE_MESSAGE_TYPES } from '../inline-message';
import { MessageDescriptorPropType } from '../../../prop-types/intl';

export const TimeTextInput = ({ className = '', value, onChange, errorMessageDescriptor = '' }) => {
  const _onChange = useCallback(
    (e) => {
      onChange(e.target.value);
    },
    [onChange],
  );
  return (
    <>
      <div className={className}>
        <input onChange={_onChange} type='time' value={value} />
      </div>
      {errorMessageDescriptor && (
        <InlineMessage type={INLINE_MESSAGE_TYPES.error}>
          <FormattedMessage {...errorMessageDescriptor} />
        </InlineMessage>
      )}
    </>
  );
};

TimeTextInput.propTypes = {
  className: PropTypes.string,
  value: PropTypes.instanceOf(Date).isRequired,
  onChange: PropTypes.func.isRequired,
  errorMessageDescriptor: MessageDescriptorPropType,
};
